export const sortByAlpha = <T extends Record<string, string>>(
  array: T[],
  sortProperty: keyof T,
): T[] =>
  array.sort((a, b) =>
    a[sortProperty].localeCompare(b[sortProperty], undefined, {
      numeric: true,
    }),
  );
